











































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';


//@ts-ignore
import indicador_administradores from '@/mixins/axios/indicador_administradores'



//@ts-ignore
import PmdHeader from '@/components/headersSelect/pmd'


//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'


@Component({
  components: {

  },
  data() {
    return {
        //idmunicipio,nombre, fecha_alta, 
            // tipo, total_empleados, nombre_titular, correo, abreviacion,
  
     

        id:null as any,

      idclasificacion:0,
      clave:'' as any,
      nombre:'' as any,
      unidad_medida_resultado:'' as any,
   aceptado:0,
     
     
         
         
              indicador_administradordata:[] as any,
           
      
    }
  },
     mixins: [indicador_administradores],
     validations: {
    
           clave: {
      required,
    },
    
           nombre: {
      required,
    },    
           unidad_medida_resultado: {
      required,
    },


   
  },
  methods:{
     
     
      limpiar(){
this.id=null;
 
           
                 this.clave=null;
                 this.nombre=null;
                 this.unidad_medida_resultado=null;
           
     
           
      },
      addRow(){
          this.limpiar();
 $('#ac_modal_indicador_administrador').modal('show')
      },
seteditar(row){


 this.id=row.id;
 this.clave=row.clave;
  this.nombre=row.nombre;
        this.unidad_medida_resultado=row.unidad_medida_resultado;
        this.aceptado=row.aceptado;
            
          
 $('#ac_modal_indicador_administrador').modal('show')
    

},
     async crear(dat){
let data= await this.CREAR_ADMINISTRADORES(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)
this.$parent.indicador_administradordata.push(response);

$('#modalCausa').modal('hide')
  //this.indicador_administradordata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar indicador desempeño enlaces, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });

      },
    
     async GuardarData(){



console.log('id:'+this.id)

let dat={
  id:this.id,
     
    
            clave:this.clave,
             nombre:this.nombre,
                   unidad_medida_resultado:this.unidad_medida_resultado,
                           aceptado:this.aceptado,
            idmunicipio:this.$store.state.user.usuario.id_municipio,

}
console.log(dat)
 this.$root.$emit('loading', true);
 if(this.id==null){
     this.crear(dat);
 }else{
       this.editar(dat);
 }

      },


  },
  mounted(){
      //this.getData();
      //alert('10')
  }
})
export default class Home extends Vue {}

